import { useState, useEffect } from 'react';
import { getConsent, subscribe, } from '@zalando-internal/zalando-consent-api';
export const useConsentManager = (serviceId) => {
    const [hasConsent, setHasConsent] = useState(false);
    useEffect(() => {
        getConsent(serviceId)
            .then((data) => {
            if (data.status) {
                setHasConsent(true);
            }
        })
            .catch(() => 
        // eslint-disable-next-line no-console
        console.warn(`Cannot get any consent info for ${serviceId}`));
        const callback = (consent) => {
            if (consent.status) {
                setHasConsent(true);
            }
        };
        const unsubscribeFn = subscribe(serviceId, callback);
        return () => {
            unsubscribeFn();
        };
    }, [serviceId]);
    return [hasConsent];
};
